<template>
  <div class="comment-container" v-if="loaded && info">
    <div class="comment-count">评论 {{ data.length }}条</div>
    <div class="comment-list">
      <div
        class="comment-item"
        v-for="(item, index) in data"
        :key="index"
        @click.stop="bindToUser(item, item, index, '')"
      >
        <img class="avatar" :src="item.user_img || defaultAvatar" alt="" />
        <div class="comment-item-right">
          <div class="comment-info">
            <div class="info-left">
              <div class="nickname">
                <span>{{ item.user_name }}</span
                ><span class="author" v-if="item.uid == info.author_id"
                  >作者</span
                >
              </div>
              <div class="time">{{ item.addtime }}</div>
            </div>
            <i class="iconfont icon-home_tab_message"></i>
          </div>
          <div class="comment-text">{{ item.comment || '' }}</div>
          <div
            class="reply-list"
            v-if="item.comment_list && item.comment_list.length"
          >
            <div v-for="(item1, index1) in item.comment_list" :key="index1">
              <div
                class="reply-item"
                v-if="item.showMore ? true : index1 < 2"
                @click.stop="bindToUser(item, item1, index, index1)"
              >
                <img
                  class="avatar reply-avatar"
                  :src="item1.user_img || defaultAvatar"
                  alt=""
                />
                <div class="comment-item-right">
                  <div class="comment-info">
                    <div class="info-left">
                      <div class="nickname">
                        <span>{{ item1.user_name }}</span>
                        <span class="author" v-if="item1.uid == info.author_id"
                          >作者</span
                        >
                        <span v-if="item.uid != item1.t_uid">
                          <span class="reply-text">回复</span>
                          <span>{{ item1.t_user_name || '' }}</span>
                        </span>
                      </div>
                      <div class="time">{{ item1.addtime }}</div>
                    </div>
                    <i class="iconfont icon-home_tab_message"></i>
                  </div>
                  <div class="comment-text">{{ item1.comment || '' }}</div>
                </div>
              </div>
            </div>
            <div
              class="show-more"
              @click.stop="bindShowMore(index)"
              v-if="!item.showMore && item.comment_list.length > 2"
              >查看全部{{ item.comment_list.length }}条回复</div
            >
          </div>
        </div>
      </div>
    </div>
    <!-- 弹出层 -->
    <DeleteContent
      v-if="showDelete"
      @delete="bindDelete"
      @reply="bindReply"
      @cancel="bindCancel"
    />
    <div> </div>
  </div>
</template>
<script>
import DeleteContent from '../delete-content/index'
export default {
  components: { DeleteContent },
  props: {
    data: {
      type: Array,
      default: () => {
        return []
      }
    },
    loaded: {
      type: Boolean,
      default: true
    },
    info: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      defaultAvatar:
        'https://cdnvue.gymcity.com.cn/uploads/b2ae63e6c8ce86d5ad1cbd0ab233ce83.png',
      chatInfo: {},
      chatParentInfo: {},
      parentIndex: '',
      index: '',
      showDelete: false
    }
  },
  created() {
    console.log(this.info)
    console.log(this.data)
  },
  methods: {
    bindDelete() {
      this.$emit(
        'delete',
        this.chatParentInfo,
        this.chatInfo,
        this.parentIndex,
        this.index
      )
      this.showDelete = false
    },
    bindReply() {
      this.showDelete = false
      console.log(
        this.chatInfo,
        this.chatParentInfo,
        this.parentIndex,
        this.index
      )
      this.$emit(
        'toUser',
        this.chatParentInfo,
        this.chatInfo,
        this.parentIndex,
        this.index
      )
    },
    bindCancel() {
      this.showDelete = false
      this.$emit('cancel')
    },
    //  parentItem父级的信息 item 要回复的人的信息
    bindToUser(parentItem, item, parentIndex, index) {
      console.log('触发')
      // 判断是不是自己评论自己
      if (item.is_self) {
        this.chatInfo = item
        this.chatParentInfo = parentItem
        this.parentIndex = parentIndex
        this.index = index
        this.showDelete = true
      } else {
        this.$emit('toUser', parentItem, item, parentIndex, index)
      }
    },
    bindShowMore(index) {
      this.$emit('showmore', index)
    }
  }
}
</script>
<style lang="scss" scoped>
.comment-container {
  .comment-count {
    text-align: left;
    font-size: 4vw;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #000;
    line-height: 5.6vw;
    margin-bottom: 5.3vw;
  }
  .comment-list {
    .comment-item {
      margin-bottom: 8.5vw;
      display: flex;
      .avatar {
        width: 9.6vw;
        height: 9.6vw;
        background: #d8d8d8;
        border-radius: 2.7vw;
        margin-right: 2.7vw;
      }
      .comment-item-right {
        flex: 1;
        flex-shrink: 0;
        overflow: hidden;
        .comment-info {
          display: flex;
          align-items: center;
          .info-left {
            text-align: left;
            flex: 1;
            flex-shrink: 0;
            overflow: hidden;
            .nickname {
              font-size: 3.2vw;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 600;
              color: #000;
              line-height: 4.5vw;
              margin-bottom: 0.8vw;
              .author {
                padding: 0vw 2.1vw;
                height: 3.5vw;
                line-height: 3.5vw;
                background: #f04646;
                border-radius: 1.6vw;
                margin-left: 2.7vw;
                font-size: 2.7vw;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #fff;
                line-height: 3.7vw;
              }
            }
            .time {
              font-size: 2.7vw;
              font-family: PingFangSC-Regular, PingFang SC;
              color: rgba(0, 0, 0, 0.5);
              line-height: 3.7vw;
            }
          }
          .iconfont {
            color: rgba(0, 0, 0, 0.19);
          }
        }
        .comment-text {
          text-align: left;
          margin-top: 2.9vw;
          font-size: 3.7vw;
          font-family: PingFangSC-Regular, PingFang SC;
          color: #000;
          line-height: 5.9vw;
        }
      }
    }
    .comment-item:last-child {
      margin-bottom: 0;
    }
  }
  .reply-list {
    background-color: #f7f7f7;
    border-radius: 2.7vw;
    padding: 4vw 3vw;
    margin-top: 2.7vw;
    .reply-item {
      display: flex;
      margin-bottom: 2vw;
      .reply-avatar {
        width: 6vw;
        height: 6vw;
      }
      .reply-text {
        margin-left: 2.7vw;
        margin-right: 2.7vw;
        font-size: 3.2vw;
        color: #999;
      }
    }
  }
  .show-more {
    text-align: left;
    font-size: 3.2vw;
    color: #2882e9;
  }
}
</style>
